import { sql } from "drizzle-orm";
import { index, pgTable, timestamp, varchar } from "drizzle-orm/pg-core";

export const passwordResetTokens = pgTable(
  "password_reset_tokens",
  {
    tokenHash: varchar("token_hash", { length: 64 }).primaryKey(),
    userId: varchar("user_id").notNull(),
    expiresAt: timestamp("expires_at", { withTimezone: true }).notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (table) => [index("idx_password_reset_tokens_user").on(table.userId)],
);

export const passwordResetRequests = pgTable(
  "password_reset_requests",
  {
    id: varchar("id").primaryKey().default(sql`gen_random_uuid()`),
    emailHash: varchar("email_hash", { length: 64 }).notNull(),
    ipHash: varchar("ip_hash", { length: 64 }).notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (table) => [
    index("idx_password_reset_requests_email_time").on(table.emailHash, table.createdAt),
    index("idx_password_reset_requests_ip_time").on(table.ipHash, table.createdAt),
  ],
);